const React = require("react");
const createReactClass = require("create-react-class");
const PT = require("prop-types");
const withSetURL = require("../core/hoc/withSetURL");
const Link = require("../core/view/Link");

const OfficeModal = require("../office/modals/OfficeModal");
const styles = require("./styles/AddModal.css");

const augment = function(Component) {
	Component = withSetURL(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "WarnModal",

		propTypes: {
			onClose: PT.func.isRequired,
			type: PT.string,

			setURL: PT.func.isRequired,
		},

		render() {
			const gotoSchoolButton = (
				<div
					className={styles.button}
					onClick={() => {
						this.props.setURL("schools");
						this.props.onClose();
					}}
				>
					View Schools
				</div>
			);

			const gotoClassButton = (
				<div className={styles.button} onClick={this.props.onClose}>
					View Classes
				</div>
			);

			return (
				<OfficeModal
					onClose={this.props.onClose}
					closeOnEsc={true}
					portalContainer={null}
					closeOnBackdropClick={true}
					level="overBar"
					modalClass={styles.fieldModal}
				>
					<div className={styles.fieldContainer}>
						<div className={styles.instructions}>
							You must{" "}
							{
								<Link
									className={styles.link}
									clickAction={() => {
										this.props.setURL("schools");
										this.props.onClose();
									}}
									forceActionOnNewTab={true}
								>
									create a school
								</Link>
							}{" "}
							first. Then, you will be able to add classes to the school.
						</div>
						<div className={styles.buttonRow}>
							{gotoSchoolButton}
							{gotoClassButton}
						</div>
					</div>
				</OfficeModal>
			);
		},
	})
);
